import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Input } from '../index';

class PeriodoVigenciaItem extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="row">
        <Grid cols="5 5 5 5">
          <Input
            disabled
            value={this.props.periodo.dataCriacaoRpps}
          />
        </Grid>
        <Grid cols="1 1 1 1">
          <Input disabled value="a" style={{ borderBottom: 'none', 'text-align': 'center' }} />
        </Grid>
        <Grid cols="6 6 6 6">
          <Input
            disabled
            value={this.props.periodo.dataEncerramentoRpps}
          />
        </Grid>
      </div>
    );
  }
}

PeriodoVigenciaItem.propTypes = {
  periodo: PropTypes.shape({
    cnpj: PropTypes.string,
    dataCriacaoRpps: PropTypes.string,
    dataEncerramentoRpps: PropTypes.string,
  }).isRequired,
};

export default PeriodoVigenciaItem;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/PeriodoVigenciaItem.jsx